import React from 'react';
import { Button } from 'antd';

const ThemeButton = (props) => {
  const {
    type = 'submit',
    text = '',
    disabled = false,
    loading = false,
    className = '',
    ...rest
  } = props;

  return (
    <Button
      {...rest}
      type={type}
      loading={loading}
      disabled={disabled}
      className={`theme-button ${className}`}
      htmlType={type}
    >
      {text}
    </Button>
  );
};

export default ThemeButton;
